import ChevronDownIcon from '@/components/icons/ChevronDownIcon';
import React, { useEffect, useRef, useState } from 'react';
import styles from './style.module.css';

export type IProps = {
  label?: string;
  helperText?: string;
  placeHolder?: string;
  errorMessage?: string;
  options?: object[];
  searchable?: boolean;
  onSelectionChange?: (value: any) => void;
};

const Drowdown: React.FC<IProps> = ({
  label,
  helperText,
  placeHolder,
  errorMessage,
  searchable = false,
  options,
  onSelectionChange,
  ...props
}) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [finishedSearch, setFinishedSearch] = useState(false);

  const dropdownRef = useRef<any>(null);

  //close dropdown when clicking away
  useEffect(() => {
    if (!isOpen) return;
    function handleClick(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [isOpen]);

  const filteredOptions =
    searchable && !finishedSearch
      ? options!.filter((option: any) =>
          option.label.toLowerCase().startsWith(searchKeyword.toLowerCase())
        )
      : options;

  const handleSelect = (option: any) => {
    if (searchable) {
      setSearchKeyword(option.label);
      setFinishedSearch(true);
    }
    setSelectedOption(option);
    setIsOpen(false);
    if (onSelectionChange) {
      onSelectionChange(option);
    }
  };

  const handleChange = (e: any) => {
    setFinishedSearch(false);
    setSearchKeyword(e);
  };

  function renderSearch() {
    if (searchable) {
      return (
        <input
          type="text"
          placeholder={placeHolder || ''}
          value={searchKeyword}
          onChange={(e) => handleChange(e.target.value)}
          className={styles.select}
        ></input>
      );
    }
    return (
      <input
        type="text"
        placeholder={placeHolder || ''}
        className={styles.select}
        value={selectedOption ? selectedOption.label : ''}
        readOnly
      ></input>
    );
  }

  return (
    /*
    <div className={styles.dropdown} {...props}>
      <p>{label}</p>
      <div className={styles.customSelect}>
        <select onChange={changeHandler} className={styles.select}>
          <option value=""></option>
          <option value="dog">Dog</option>
          <option value="cat">Cat</option>
          <option value="hamster">Hamster</option>
          <option value="parrot">Parrot</option>
          <option value="spider">Spider</option>
        </select>
        <ChevronDownIcon className={styles.icon} />
      </div>
    </div>
    */

    <div className={styles.dropdown} {...props} ref={dropdownRef}>
      <p>{label}</p>
      <div className={styles.customSelect} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.panel}>
          {renderSearch()}
          <ChevronDownIcon className={styles.icon} />
        </div>
        {isOpen && (
          <div className={styles['select-options']}>
            <ul>
              {filteredOptions!.map((option: any, index) => (
                <li
                  key={index}
                  onClick={() => handleSelect(option)}
                  className={styles.option}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Drowdown;
